module.exports = __webpack_public_path__ + "nz.6bb1f1bd.svg";